<template>
    <div class="pl-2 pr-8">
        <Loading v-if="isLoading"/>
        <v-row>
            <v-col md="6" lg="6" xl="4" class="user-block" v-for="(item, index) in items" :key="item.id">
                <IdentityItem v-model="items[index]" :id="item.id" :index="index" v-on:update:set-default="onSetDefault"></IdentityItem>

                <v-btn class="btn-add-group text-center" rounded outlined color="#47266F" @click="toggleAddForm" v-if="!isAddMode && items.length === index + 1">
                    <v-icon block v-text="'$plus_square'" color="#47266F" class="mb-1"></v-icon>AJOUTER
                </v-btn>

            </v-col>
            <v-col md="6" lg="6" xl="4" class="user-block" v-if="isAddMode || items.length === 0">
                <AddIdentityForm v-on:update:added="onAdded" v-on:update:cancelled="onCancelled" v-on:update:set-default="onSetDefault"></AddIdentityForm>
            </v-col>
        </v-row>
    </div>
</template>

<script>
  import IdentityService from '@/services/identity.service.js';
  import ImagePickerInput from '@/components/inputs/ImagePickerInput.vue';
  import CountryPickerInput from '@/components/inputs/CountryPickerInput.vue';
  import AddIdentityForm from '@/components/forms/AddIdentityForm.vue';
  import IdentityItem from '@/components/IdentityItem.vue';
  import { ValidationObserver, ValidationProvider } from "vee-validate";
  import Loading from '@/components/Loading.vue'

  export default {
    name: "IdentityList",
    components: {
      ImagePickerInput,
      CountryPickerInput,
      AddIdentityForm,
      IdentityItem,
      ValidationObserver,
      ValidationProvider,
      Loading
    },
    data: () => ({
      items: [],
      formAdd: {},
      formEdit: {},
      editId: null,
      isAddMode: false,
      isInProgressAdd: false,
      isLoading: true,
    }),
    created() {
      this.fetch();
    },
    computed: {
      pageHeight () {
        return document.body.scrollHeight
      }
    },
    methods: {
      async fetch() {
        const {data} = await IdentityService.getAll();

        this.items = data;

        this.isLoading = false;
      },
      async add() {
        const success = await this.$refs.formAdd.validate();

        if (!success) {
            return;
        }

        try {
          this.isInProgressAdd = true;

          // Add
          const {data} = await IdentityService.create(this.formAdd);

          // Get by id
          const response = await IdentityService.getById(data.id);

          this.items.push(response.data);

          this.closeAddForm();

          this.successMessage('Identity added successfully');
        } catch (e) {
          this.handleError(e);
        }
        this.isInProgressAdd = false;

      },
      onSetDefault(id) {
        const _this = this;

        this.items.forEach((item, index) => {
          if (Number(id) === item.id) {
            item.isActive = true;
          } else {
            item.isActive = false;
          }

          _this.$set(_this.items, index, item);
        });
      },
      toggleAddForm() {
        this.$vuetify.goTo(this.pageHeight);
        this.isAddMode = true;
      },
      onAdded(data) {
        this.items.push(data);
        this.isAddMode = false;
      },
      onCancelled() {
        this.isAddMode = false;
      }
    }
  }
</script>

<style scoped>

</style>
